import { gql } from "@apollo/client"

const GET_SYSTEM_TEMPLATES = gql`
  query Templates($staff_id: String!) {
    systemTemplates: templates(type: "system", staff_id: $staff_id) {
      idTemplate
      template_description
      template_name
      template_title
      template_type
    }
  }
`

const GET_TEMPLATES_LIBRARY = gql`
  query Templates(
    $staff_id: String!
    $organization_id: ID
    $enterprise_id: ID
  ) {
    systemTemplates: templates(
      type: "system"
      staff_id: $staff_id
      enterprise_id: $enterprise_id
      organization_id: $organization_id
    ) {
      idTemplate
      template_description
      template_name
      template_title
      template_type
      allow_custom_config
    }
    customTemplates: templates(
      type: "custom"
      staff_id: $staff_id
      enterprise_id: $enterprise_id
      organization_id: $organization_id
    ) {
      idTemplate
      template_description
      template_name
      template_title
      template_type
      enterprise_id
      organization_id
      organization_name
      enterprise_name
    }
  }
`

const GET_CUSTOM_TEMPLATES = gql`
  query Templates($staff_id: String!, $organization_id: ID) {
    customTemplates: templates(
      type: "custom"
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      idTemplate
      template_description
      template_name
      template_title
      template_type
      enterprise_id
      organization_id
      organization_name
      enterprise_name
    }
  }
`

const GET_ORGANIZATIONS_BY_ENTERPRISE = gql`
  query GetOrganizationsByEnterprise($staff_id: ID!, $enterprise_id: ID!) {
    organizationsByEnterpriseUid(
      staff_id: $staff_id
      enterprise_id: $enterprise_id
    ) {
      organization_id
      organization_name
      organization_status
    }
  }
`

const GET_TEMPLATE = gql`
  query GetParentTemplate(
    $idTemplate: ID!
    $organization_id: ID
    $staff_id: ID!
    $type: ID!
    $participant_id: ID!
  ) {
    currentTemplate: template(
      idTemplate: $idTemplate
      staff_id: $staff_id
      organization_id: $organization_id
      participant_id: $participant_id
      type: $type
    ) {
      template_availability
      allow_custom_config
      template_name
      template_title
      template_description
      template_type
      kiosk
      template_parent {
        template_name
      }
      blocks {
        idBlock
        index
        block_name
        block_title
        block_parent {
          block_name
        }
        configuration {
          system_required
        }
      }
    }
    systemBlocks: blocks(type: "system", organization_id: $organization_id) {
      idBlock
      block_name
      block_title
      block_parent {
        block_name
      }
    }
    customBlocks: blocks(type: "custom", organization_id: $organization_id) {
      idBlock
      block_name
      block_title
      block_parent {
        block_name
      }
    }
  }
`
const ADD_TEMPLATE = gql`
  mutation AddTemplate(
    $organization_id: String!
    $enterprise_id: String!
    $created_by: String!
    $updated_by: String!
    $template_availability: Int!
    $template_name: String!
    $template_description: String!
    $template_parent: String
    $template_title: String!
    $template_type: String!
    $blocks: String!
    $kiosk: Int
  ) {
    addTemplate(
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      created_by: $created_by
      updated_by: $updated_by
      template_availability: $template_availability
      template_name: $template_name
      template_description: $template_description
      template_parent: $template_parent
      template_title: $template_title
      template_type: $template_type
      blocks: $blocks
      kiosk: $kiosk
    ) {
      template_title
    }
  }
`

const EDIT_TEMPLATE = gql`
  mutation EditTemplate(
    $idTemplate: String!
    $organization_id: String!
    $enterprise_id: String!
    $updated_by: String!
    $template_availability: Int!
    $template_name: String!
    $template_description: String!
    $template_parent: String
    $template_title: String!
    $template_type: String!
    $kiosk: Int
    $blocks: String!
  ) {
    editTemplate(
      idTemplate: $idTemplate
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      updated_by: $updated_by
      template_availability: $template_availability
      template_name: $template_name
      template_description: $template_description
      template_parent: $template_parent
      template_title: $template_title
      template_type: $template_type
      kiosk: $kiosk
      blocks: $blocks
    ) {
      template_title
    }
  }
`

const DELETE_CUSTOM_TEMPLATE = gql`
  mutation DeleteCustomTemplate($id: String!) {
    deleteCustomTemplate: deleteTemplate(id: $id) {
      idTemplate
    }
  }
`
export {
  GET_TEMPLATES_LIBRARY,
  GET_TEMPLATE,
  GET_SYSTEM_TEMPLATES,
  GET_CUSTOM_TEMPLATES,
  GET_ORGANIZATIONS_BY_ENTERPRISE,
  ADD_TEMPLATE,
  EDIT_TEMPLATE,
  DELETE_CUSTOM_TEMPLATE,
}
